import { Component, OnInit, OnDestroy, Input, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { WidgetManifest, ToastrService } from '@kpmg-tax/ui';
import { AdminMenuComponent } from './core/menus/admin-menu';
import { AuthorizationService } from './core/auth/authorization.service';
import { environment } from '../environments/environment';
import { SessionService } from './shared/session-service/session.service';
import { RightSideDrawerService } from './shared/right-side-drawer/right-side-drawer.service';
import { role } from './shared/constants/role-enum';
import { FeedbackStatus } from './shared/constants/feedback-status.enum';
import { InfoMenuComponent } from './core/menus/info-menu/info-menu.component';
import { API_URL } from './shared/constants/apiurl-constants';
import { Messages } from './shared/constants/messages';
import { UserDataService } from './core/services/user-data.service';
import { filter } from 'rxjs/operators';
import { AppInsightsService } from './core/services/app-insights.service';
import { TopNavigationService } from 'src/app/shared/navigation/top-navbar/top-nav.service';
import { encodeText, decodeText, isRcnSurveyApplication } from 'src/app/shared/lib/custom-tools';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    private _subscriptions: Subscription[] = [];
    userMenuWidget: WidgetManifest;
    adalConfig: any;
    appUrl: string = environment.appUrl;
    initials = '';
    icon = 'fas fa-user';
    isEnvProd: boolean;
    toolbarItems: any[];
    isActiveShelf: boolean;
    isDarkTheme: boolean;
    roleId: number;
    isMainAppInstance: boolean;
    @Input() loginComplete = false;
    signInDone: boolean;
    assetURL: string = environment.cdnHostname + environment.assetRootUrl;

    showFeedbackTextInput = false;
    pageURL: string;
    feedBackStatus = 0;
    pageFeedbacks: any[];
    feedBack = '';
    isSendActive = false;
    isSendHover = false;
    isSendingFeedback = false;
    isThumbsUpHover = false;
    isThumbsDownHover = false;
    isShowCommentHover = false;
    isCloseImgHover = false;
    feedSentSuccessMsg: string = Messages.FEEDBACK.SEND_SUCCESS;
    isWelcomeScreen: boolean = false;
    isReconcileButtonVisible: boolean = false;
    imgSrcThumbsUp = '../assets/Thumb-up.svg';
    imgSrcThumbsUpClicked = '../assets/Thumb-up Clicked.svg';
    imgSrcThumbsUpHover = '../assets/Thumb-up Hover.svg';
    imgSrcThumbsDown = '../assets/Thumb-down.svg';
    imgSrcThumbsDownClicked = '../assets/Thumb-down Clicked.svg';
    imgSrcThumbsDownHover = '../assets/Thumb-down Hover.svg';
    imgSrcFeedbackHide = '../assets/Hide.svg';
    imgSrcHeedbackHideHover = './assets/Hide Hover.svg';
    imgSrcSendFeedback = './assets/Send Inactive.svg';
    imgSrcSendFeedbackActive = './assets/Send Active.svg';
    imgSrcSendFeedbackActiveHover = './assets/Send Active Hover.svg';
    imgSrcComment = './assets/Button Comment.svg';
    imgSrcCommentHover = './assets/Button Comment Hover.svg';
    imgSrcClose = './assets/Button close.svg';
    imgSrcCloseHover = './assets/Button close Hover.svg';
    clickObservable: Observable<Event> = fromEvent(document, 'click');
    userId = 0;

    constructor(
        private _router: Router,
        private _userDataService: UserDataService,
        private _appInsightsService: AppInsightsService,
        private _authService: AuthorizationService,
        private _sessionService: SessionService,
        private _rightSideDrawerService: RightSideDrawerService,
        public _topNavigationService: TopNavigationService,
        private _toastrService: ToastrService,
        private _changeDetector: ChangeDetectorRef
    ) {
        if (environment.production) {
            this.isEnvProd = environment.production;
        }
        if (isRcnSurveyApplication()) {
            this.imgSrcThumbsUp = './assets/Thumb-up.svg';
            this.imgSrcThumbsUpClicked = './assets/Thumb-up Clicked.svg';
            this.imgSrcThumbsUpHover = './assets/Thumb-up Hover.svg';
            this.imgSrcThumbsDown = './assets/Thumb-down.svg';
            this.imgSrcThumbsDownClicked = './assets/Thumb-down Clicked.svg';
            this.imgSrcThumbsDownHover = './assets/Thumb-down Hover.svg';
        }
        this.initials = this._sessionService.getSession('initials');

        if (this.initials) {
            this.icon = '';
        }

        _router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
            if (event["url"] === "/welcome") {
                this.isWelcomeScreen = true;
            } else {
                this.isWelcomeScreen = false;
            }
        });

        this._subscriptions.push(
            this._router.events.subscribe(() => {
                // If it is a NavigationEnd event re-initalise the component
                if (event instanceof NavigationEnd) {
                    // Trick the Router into believing it's last link wasn't previously loaded
                    this._router.navigated = false;
                }
            })
        );

        this._subscriptions.push(
            this._userDataService.userDetails$.subscribe((userDetals) => {
                this.roleId = userDetals.roleId;
                this.toolbarItems = [];
                if (
                    this.roleId !== role.respondent &&
                    this.roleId !== role.clientManager
                ) {
                    this.createToolbarItems();
                }
            })
        );

        this._router.events.subscribe((event: any) => {

            if (event instanceof NavigationEnd) {
                // Hide progress spinner or progress bar
                // this.currentRoute = event.url;
                this.pageURL = event.url;
                const url = event.url;
                const userID = this.userId;
                const engagementID = this._sessionService.getSession('engagementId');

                if (userID != null) {
                    const queryString = (engagementID == null) ? '' : '?engagementID=' + engagementID;
                    this._sessionService.apiUrlGet(API_URL.PAGEFEEDBACK.GETPAGEFEEDBACKS + queryString).subscribe((data: any) => {
                        this.pageFeedbacks = data.result;
                        const pageData = this.pageFeedbacks.filter((page) => {
                            return page.pageURL == url;
                        });

                        if (pageData.length > 0) {
                            this.feedBackStatus = pageData[0].feedbackStatus;
                        }
                        else {
                            this.feedBackStatus = 0;
                        }
                    });
                }

                this.feedBack = '';
                this.isSendActive = (this.feedBackStatus == 2);


            }

        });

    }

    ngOnInit(): void {
        this._userDataService.userDetails$.subscribe(({ roleId, userId }) => {
            if (roleId > 0) {
                this.userId = userId
                this.signInDone = true;
                this.roleId = roleId;
            }
        });
        this.clickEventSubscribe();
    }

    ngOnDestroy(): void {
        this._subscriptions.forEach(s => s.unsubscribe());
    }
    checksignin(loginComplete) {
        this.signInDone = loginComplete;
        this._changeDetector.detectChanges();
    }

    private createToolbarItems(): void {
        const adminMenu: WidgetManifest = {
            uniqueId: 'adminMenu',
            title: 'Admin',
            icon: 'fas fa-cog',
            componentType: AdminMenuComponent,
            data: null
        };
        const info: WidgetManifest = {
            uniqueId: 'info',
            title: 'Info',
            icon: 'fas fa-question-circle',
            componentType: InfoMenuComponent,
            data: null
        };
        const emailMenu: any = {
            uniqueId: 'emailMenu',
            title: 'Email',
            icon: 'fas fa-envelope',
            data: null
        };

        this.toolbarItems = [emailMenu, info, adminMenu];
    }

    closeDrawerIfOpen() {
        this._rightSideDrawerService.rightSideDrawerControl = false;
    }

    closeDrawer() {
        this._rightSideDrawerService.closeRightSideDrawer();
    }

    loginIn() {
        this.isWelcomeScreen = false;
        this._router.navigate(['/']).then(() => {
            window.location.reload();
        });
    }

    private clickEventSubscribe(): void {
        this.clickObservable.subscribe(event => {
            this._appInsightsService.logEvent('Ui click event', {});
        })
    }

    toggleFeedback() {
        this.showFeedbackTextInput = !this.showFeedbackTextInput;
    }

    setLike(feedBackStatus: number) {
        if (!this.isSendingFeedback) {
            this.isSendingFeedback = true;
            this.feedBackStatus = feedBackStatus;
            const page = {
                pageURL: this.pageURL,
                userName: '',
                engagementID: this._sessionService.getSession('engagementId'),
                feedback: this.getFeedback(),
                feedbackStatus: feedBackStatus
            };
            this._sessionService.apiUrlPost(API_URL.PAGEFEEDBACK.INSERTPAGEFEEDBACK, page).subscribe((data: any) => {
                this.feedBack = '';
                if (data.success) {
                    this.feedBack = ' ';
                    this._toastrService.setSuccessMessage(
                        this.feedSentSuccessMsg
                    );
                }
                else {
                    this._toastrService.setErrorMessage(
                        Messages.FEEDBACK.SEND_ERROR
                    );
                }
                this.isSendingFeedback = false;
                this.isSendActive = false;
                setTimeout(() => {
                    this.feedBack = '';
                }, 2000);
            });
        }
    }

    private getFeedback()
    {
        var feedBack = this.feedBack?.length > 0
            ? this.feedBack.trim()
            : '';
        return encodeText(feedBack);
    }

    public getThumbsUpIcon() {
        return this.feedBackStatus === FeedbackStatus.Like
            ? this.imgSrcThumbsUpClicked
            : this.isThumbsUpHover ? this.imgSrcThumbsUpHover : this.imgSrcThumbsUp;
    }

    public getThumbsDownIcon() {
        return this.feedBackStatus === FeedbackStatus.Dislike
            ? this.imgSrcThumbsDownClicked
            : this.isThumbsDownHover ? this.imgSrcThumbsDownHover : this.imgSrcThumbsDown;
    }

    public getShowCommentIcon() {
        return this.isShowCommentHover ? this.imgSrcCommentHover : this.imgSrcComment;
    }

    public getSendFeedbackArrowIcon() {
        return this.isSendHover
            ? this.imgSrcSendFeedbackActiveHover
            : this.isSendActive ? this.imgSrcSendFeedbackActive : this.imgSrcSendFeedback;
    }

    public setThumbsUpHover(isHover: boolean) {
        this.isThumbsUpHover = isHover;
    }

    public setThumbsDownHover(isHover: boolean) {
        this.isThumbsDownHover = isHover;
    }

    public setShowCommentHover(isHover: boolean) {
        this.isShowCommentHover = isHover;
    }

    public setSendFeedbackHover(isHover: boolean) {
        this.isSendHover = isHover;
    }

    public setCloseHover(isHover: boolean) {
        this.isCloseImgHover = isHover;
    }
}
